import styled from "styled-components";

import { media } from "constants/media";

export const Wrapper = styled.div<{ visible?: boolean }>`
    background-color: var(--color-white);
    box-shadow: 0 -28px 80px var(--color-black);
    display: flex;
    flex-direction: column;
    height: 104px;
    left: 0;
    padding: 8px 24px;
    position: fixed;
    right: 0;
    top: 0;
    transform: ${({ visible }) =>
        visible ? "translateY(0px)" : "translateY(-104px)"};
    transition: all 0.2s ease-in-out;
    z-index: var(--z-index-header);

    ${media.lgUp} {
        flex-direction: row;
        height: 96px;
        padding: 16px 120px 20px;
    }
`;

export const VacancyInfo = styled.div`
    ${media.mdUp} {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        gap: 8px;
    }

    ${media.lgUp} {
        transform: scale(0.9);
    }

    ${media.xlUp} {
        transform: scale(1) translateX(55px);
    }
`;

export const DetailedInfo = styled.div`
    align-items: center;
    display: flex;
    gap: 28px;

    svg {
        margin-right: 8px;
    }
`;

export const IconWrapper = styled.p`
    align-items: center;
    color: var(--color-grey-60);
    display: flex;
    font-weight: var(--font-weight-extra-bold);
`;

export const Title = styled.h5`
    font-size: var(--type-heading-5-font-size);
    font-weight: var(--font-weight-semibold);
    line-height: var(--type-heading-5-line-height);
    max-width: 480px;
    min-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${media.xlUp} {
        max-width: 60vw;
    }
`;

export const Department = styled.div`
    background: var(--color-grey-50);
    border-radius: 16px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 1px;
    line-height: 16px;
    padding: 4px 8px;
    text-transform: uppercase;
`;

export const ApplyButtonWrapper = styled.div`
    button {
        justify-content: center;
        width: 100%;
    }
`;

export const LogoWrapper = styled.div`
    cursor: pointer;
    margin: auto 0;
`;

export const RecruiterContact = styled.div`
    color: var(--color-orange-60);
    cursor: pointer;
    margin: auto 24px auto 0;
    text-align: center;
    text-decoration: underline;
    z-index: 10;

    p {
        color: var(--color-orange-60);
        font-weight: var(--font-weight-extra-bold);
    }
`;
